module.exports = __webpack_public_path__ + "static/media/corte_laser_1.59fab89b.png";